/* assets/verlanglijst-beheer.js
 * Mijn verlanglijst, v2 KISS (21-10-2026). Hoort bij sections/verlanglijst-beheer.liquid.
 * Gebruikt window.Verlanglijst uit assets/verlanglijst.js (wordt eerder geladen, beide defer).
 *
 * - Wensen: foto, korte titel, prijs, ster "Topwens" (prioriteit hoog/normaal) en prullenbak. Elke klik
 *   slaat direct op (PATCH of DELETE) en toont "Opgeslagen". Geen formulier en geen Opslaan-knoppen meer.
 * - Cadeau-ideeën per prijsklasse uit assets/verlanglijst-content.json (blok inspiratie); productgegevens via
 *   /products/<handle>.js, wat niet beschikbaar is of buiten de prijsklasse valt verdwijnt. De digitale
 *   cadeaukaart staat vooraan met het bedrag van de tab. De hartjes daarin werken via assets/verlanglijst.js.
 * - Vaste balk (vanaf 1 wens): aantal, totaal en "Stuur naar familie via WhatsApp" opent het deelvenster
 *   (<dialog>): voornaam (wordt de lijstnaam), optioneel een rijmpje of kerstwens, WhatsApp en link kopiëren.
 * - Digitale schoen (vanaf 1 wens): opt-in voor de tips (emailOptin; gast ook e-mailadres). Geen korting,
 *   geen prijs, geen winactie (besluit Kees 20-10-2026).
 *
 * De wenser ziet nooit wat er gekocht of afgestreept is: het beheerantwoord bevat geen aankoopinformatie.
 * Alle klanttekst (naam, rijm, producttitels) gaat via textContent of .value de pagina in, nooit als HTML.
 * Prijzen zijn centen (integers). Contract: retailz-server docs/verlanglijst/C-thema.md en BACKEND.md.
 */
(function () {
  'use strict';

  function init() {
    var VL = window.Verlanglijst;
    var wortel = document.querySelector('[data-vl-beheer]');
    if (!VL || !wortel || wortel.getAttribute('data-vl-init') === '1') return;
    wortel.setAttribute('data-vl-init', '1');
    var fab = document.getElementById('sos-fab');
    if (fab) fab.style.display = 'none';

    var DATA = {};
    try { DATA = JSON.parse(document.getElementById('vl-beheer-data').textContent); } catch (e) { DATA = {}; }
    var T = DATA.teksten || {};
    var pagina = document.querySelector('.vl-beheer');
    var seizoen = pagina ? pagina.getAttribute('data-vl-seizoen') : 'neutraal';
    var lijstEl = wortel.querySelector('[data-vl-itemlijst]');
    var sjabloon = document.querySelector('[data-vl-item-sjabloon]');
    var ideeSjabloon = document.querySelector('[data-vl-idee-sjabloon]');
    var ideeen = document.querySelector('[data-vl-ideeen]');
    var schoen = document.querySelector('[data-vl-schoen]');
    var balk = document.querySelector('[data-vl-balk]');
    var sheet = document.querySelector('[data-vl-sheet]');
    var huidige = null;
    var contentBelofte = null;

    var euro = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
    function prijs(centen) {
      var n = parseInt(centen, 10);
      return isFinite(n) ? euro.format(n / 100) : '';
    }
    function vul(tekst, waarden) {
      var t = String(tekst || '');
      Object.keys(waarden).forEach(function (k) { t = t.split('__' + k + '__').join(waarden[k]); });
      return t;
    }
    function standaardNaam(n) {
      return !n || n === VL.teksten.standaardNaam || n === 'Mijn verlanglijstje';
    }
    function items() { return (huidige && huidige.items) || []; }
    function beeld(src, breedte) {
      var s = String(src || '');
      if (s.indexOf('//') === 0) s = 'https:' + s;
      if (!/^https:\/\//.test(s)) return '';
      return s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=' + breedte;
    }
    function lijstPad() { return '/lijst/' + encodeURIComponent(VL.stand().token); }

    /* ── Staat en laden ───────────────────────────────────────────────── */
    function toon(staat) {
      wortel.setAttribute('data-vl-staat', staat);
      var delen = wortel.querySelectorAll('[data-vl-toon]');
      for (var i = 0; i < delen.length; i++) delen[i].hidden = delen[i].getAttribute('data-vl-toon') !== staat;
    }

    function fout(f) {
      wortel.querySelector('[data-vl-fouttekst]').textContent = VL.foutTekst(f);
      toon('fout');
    }

    function laad() {
      if (!VL.stand().token) {
        /* Nog geen lijst op dit apparaat: het eerste hartje maakt hem (assets/verlanglijst.js). */
        huidige = null;
        lijstEl.textContent = '';
        toon('leeg');
        werkAllesBij();
        return Promise.resolve();
      }
      if (!huidige) toon('laden');
      return VL.haalLijst().then(function (lijst) {
        huidige = lijst;
        VL.synchroniseer(lijst);
        return vulItems(lijst.items || []);
      }).then(function () {
        toon(items().length ? 'lijst' : 'leeg');
        werkAllesBij();
      }, function (f) {
        if (f && f.status === 404 && f.code === 'NIET_GEVONDEN') {
          /* Lijst bestaat niet meer of de sleutel hoort er niet bij. Alleen dan vergeten: een 404
             NOG_NIET_BESCHIKBAAR (schakelaar dicht), 401/403 of een storing mag een gast zijn
             beheersleutel niet kosten, die is nergens anders bewaard (QA G 20-10-2026). */
          VL.vergeet();
          huidige = null;
          lijstEl.textContent = '';
          toon('leeg');
          werkAllesBij();
          return;
        }
        fout(f);
      });
    }

    /* Een hartje ergens op de pagina (cadeau-ideeën) verandert de lijst: opnieuw ophalen, kort gebundeld. */
    var herlaadTimer = null;
    document.addEventListener('verlanglijst:gewijzigd', function () {
      clearTimeout(herlaadTimer);
      herlaadTimer = setTimeout(laad, 250);
    });

    /* ── Wensen ───────────────────────────────────────────────────────── */
    /* De server geeft titel, foto, prijs en url per item mee (BACKEND.md par. 3). Faalde dat, dan halen we
       het zelf op: /variants/<id> stuurt door naar /products/<handle>?variant=<id>, daarna .js. */
    function variantNummer(v) {
      var m = /(\d+)$/.exec(String(v || ''));
      return m ? m[1] : null;
    }

    function productInfo(it) {
      if (it.titel || it.title) return Promise.resolve(it);
      var nr = variantNummer(it.variantId);
      if (!nr) return Promise.resolve(it);
      return fetch('/variants/' + nr, { method: 'HEAD', credentials: 'same-origin' }).then(function (res) {
        var m = /\/products\/([a-z0-9][a-z0-9-]*)/.exec(new URL(res.url).pathname);
        if (!m) throw new Error('geen product');
        return fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
          var variant = (p.variants || []).filter(function (v) { return String(v.id) === nr; })[0] || {};
          return Object.assign({}, it, {
            titel: p.title,
            variantTitel: variant.title,
            prijs: variant.price,
            afbeelding: (variant.featured_image && variant.featured_image.src) || p.featured_image || '',
            url: '/products/' + m[1] + '?variant=' + nr
          });
        });
      }).catch(function () { return it; });
    }

    function vulItems(lijst) {
      return Promise.all(lijst.map(productInfo)).then(function (verrijkt) {
        if (huidige) huidige.items = verrijkt;
        lijstEl.textContent = '';
        verrijkt.forEach(function (it) { lijstEl.appendChild(bouwItem(it)); });
      });
    }

    function bouwItem(it) {
      var li = sjabloon.content.firstElementChild.cloneNode(true);
      var veld = function (naam) { return li.querySelector('[data-vl-veld="' + naam + '"]'); };
      var titel = VL.pure.kortTitel(it.titel || it.title || 'Product');
      li.setAttribute('data-vl-item-id', String(it.id));
      var foto = beeld(it.afbeelding || it.image, 160);
      if (foto) veld('foto').src = foto; else veld('foto').remove();
      var url = typeof it.url === 'string' && it.url.charAt(0) === '/' ? it.url : null;
      if (url) { veld('titel').href = url; veld('fotolink').href = url; } else { veld('titel').removeAttribute('href'); veld('fotolink').removeAttribute('href'); }
      veld('titel').textContent = titel;
      veld('variant').textContent = it.variantTitel && it.variantTitel !== 'Default Title' ? it.variantTitel : '';
      veld('prijs').textContent = prijs(it.prijs != null ? it.prijs : it.price);
      var top = it.prioriteit === 'hoog';
      li.classList.toggle('is-top', top);
      var ster = li.querySelector('[data-vl-actie="topwens"]');
      ster.setAttribute('aria-pressed', top ? 'true' : 'false');
      ster.setAttribute('aria-label', vul(T.topwensAria, { PRODUCT: titel }));
      li.querySelector('[data-vl-actie="verwijder"]').setAttribute('aria-label', vul(T.verwijderAria, { PRODUCT: titel }));
      return li;
    }

    lijstEl.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-vl-actie]');
      if (!knop || knop.getAttribute('aria-busy') === 'true') return;
      var li = knop.closest('[data-vl-item]');
      var id = li.getAttribute('data-vl-item-id');
      var pad = lijstPad() + '/items/' + encodeURIComponent(id);
      var it = items().filter(function (x) { return String(x.id) === id; })[0] || {};
      knop.setAttribute('aria-busy', 'true');

      if (knop.getAttribute('data-vl-actie') === 'topwens') {
        var aan = knop.getAttribute('aria-pressed') !== 'true';
        knop.setAttribute('aria-pressed', aan ? 'true' : 'false'); /* optimistisch */
        li.classList.toggle('is-top', aan);
        VL.api('PATCH', pad, { prioriteit: aan ? 'hoog' : 'normaal' }).then(function () {
          it.prioriteit = aan ? 'hoog' : 'normaal';
          VL.meld(T.opgeslagen, false);
        }, function (f) {
          knop.setAttribute('aria-pressed', aan ? 'false' : 'true');
          li.classList.toggle('is-top', !aan);
          VL.meld(VL.foutTekst(f), false);
        }).then(function () { knop.removeAttribute('aria-busy'); });
        return;
      }

      VL.api('DELETE', pad).catch(function (f) {
        if (f.status !== 404) throw f; /* al weg op de server: hier ook weghalen */
      }).then(function () {
        var volgende = li.nextElementSibling || li.previousElementSibling;
        li.remove();
        huidige.items = items().filter(function (x) { return String(x.id) !== id; });
        VL.synchroniseer(huidige);
        VL.meld(T.verwijderd, false);
        if (!items().length) toon('leeg');
        werkAllesBij();
        /* Focus niet kwijtraken: naar de volgende wens, anders naar de kop van de ideeën. */
        var doel = volgende ? volgende.querySelector('[data-vl-actie="verwijder"]') : document.getElementById('vl-ideeen-kop');
        if (doel) { if (!volgende) doel.setAttribute('tabindex', '-1'); doel.focus(); }
      }, function (f) {
        knop.removeAttribute('aria-busy');
        VL.meld(VL.foutTekst(f), false);
      });
    });

    /* ── Samenvatting: teller, balk, schoen, ideeën ───────────────────── */
    function werkAllesBij() {
      var n = items().length;
      var aantalEl = wortel.querySelector('[data-vl-aantal]');
      if (aantalEl) aantalEl.textContent = n ? '(' + n + ')' : '';
      var totaal = prijs(VL.pure.totaalCenten(items()));
      balk.querySelector('[data-vl-balk-tekst]').textContent = n === 1 ? vul(T.balkEen, { PRIJS: totaal }) : vul(T.balk, { AANTAL: String(n), PRIJS: totaal });
      balk.hidden = n === 0;
      document.documentElement.classList.toggle('vl-balk-aan', n > 0);
      schoen.hidden = n === 0;
      werkSchoenBij();
      var kop = ideeen.querySelector('[data-vl-ideeen-kop]');
      kop.textContent = n ? T.ideeenVol : T.ideeenLeeg;
      ideeen.classList.toggle('vl-ideeen--compact', n > 0);
    }

    /* ── Cadeau-ideeën ────────────────────────────────────────────────── */
    function content() {
      if (!contentBelofte) {
        contentBelofte = fetch(DATA.contentUrl, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; });
      }
      return contentBelofte;
    }

    var producten = {};
    function product(handle) {
      if (!producten[handle]) {
        producten[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return producten[handle];
    }

    function ideeVan(p, tab, isKaart) {
      if (!p || !p.available || !Array.isArray(p.variants)) return null;
      var beschikbaar = p.variants.filter(function (v) { return v.available; });
      var variant = isKaart
        ? (beschikbaar.filter(function (v) { return v.price === tab.cadeaukaart_cent; })[0] || beschikbaar[0])
        : beschikbaar[0];
      if (!variant) return null;
      if (!isKaart && ((tab.min_cent != null && variant.price < tab.min_cent) || (tab.max_cent != null && variant.price > tab.max_cent))) return null;
      return {
        titel: VL.pure.kortTitel(p.title),
        variant: String(variant.id),
        product: String(p.id),
        prijs: variant.price,
        beeld: (variant.featured_image && variant.featured_image.src) || p.featured_image || '',
        url: '/products/' + p.handle + (isKaart ? '?variant=' + variant.id : '')
      };
    }

    function bouwIdee(idee) {
      var li = ideeSjabloon.content.firstElementChild.cloneNode(true);
      var veld = function (naam) { return li.querySelector('[data-vl-veld="' + naam + '"]'); };
      var foto = beeld(idee.beeld, 360);
      if (foto) veld('foto').src = foto; else veld('foto').remove();
      veld('titel').textContent = idee.titel;
      veld('titel').href = idee.url;
      veld('fotolink').href = idee.url;
      veld('prijs').textContent = prijs(idee.prijs);
      var hart = li.querySelector('[data-vl-hartje]');
      hart.setAttribute('data-vl-variant', idee.variant);
      hart.setAttribute('data-vl-product', idee.product);
      hart.setAttribute('data-vl-titel', idee.titel);
      return li;
    }

    var tabs = [];
    var actief = -1;
    var kaartHandle = '';
    function bouwTabs() {
      content().then(function (c) {
        var ins = c && c.inspiratie;
        if (!ins || !Array.isArray(ins.tabs) || !ins.tabs.length || !ideeSjabloon) return;
        tabs = ins.tabs;
        kaartHandle = typeof ins.cadeaukaart === 'string' ? ins.cadeaukaart : '';
        var lijst = ideeen.querySelector('[data-vl-tabs]');
        lijst.textContent = '';
        tabs.forEach(function (tab, i) {
          var knop = document.createElement('button');
          knop.type = 'button';
          knop.className = 'vl-pill';
          knop.id = 'vl-tab-' + String(tab.id).replace(/[^a-z0-9-]/g, '');
          knop.setAttribute('role', 'tab');
          knop.setAttribute('aria-selected', 'false');
          knop.setAttribute('tabindex', '-1');
          knop.setAttribute('data-vl-tab', String(i));
          knop.textContent = tab.label;
          lijst.appendChild(knop);
        });
        ideeen.hidden = false;
        kies(0, false);
      });
    }

    function kies(i, focus) {
      if (i === actief || !tabs[i]) return;
      actief = i;
      var knoppen = ideeen.querySelectorAll('[data-vl-tab]');
      for (var k = 0; k < knoppen.length; k++) {
        var aan = k === i;
        knoppen[k].setAttribute('aria-selected', aan ? 'true' : 'false');
        knoppen[k].setAttribute('tabindex', aan ? '0' : '-1');
      }
      if (focus) knoppen[i].focus();
      var raster = ideeen.querySelector('[data-vl-raster]');
      raster.setAttribute('aria-labelledby', knoppen[i].id);
      raster.setAttribute('aria-busy', 'true');
      if (!raster.children.length) {
        /* Eerste keer: vaste plekhouders, zodat de pagina niet verspringt. */
        for (var s = 0; s < 4; s++) {
          var leeg = document.createElement('li');
          leeg.className = 'vl-idee vl-idee--skelet';
          leeg.setAttribute('aria-hidden', 'true');
          raster.appendChild(leeg);
        }
      }
      var tab = tabs[i];
      var handles = (kaartHandle ? [kaartHandle] : []).concat(Array.isArray(tab.handles) ? tab.handles : []);
      Promise.all(handles.map(product)).then(function (ps) {
        if (actief !== i) return;
        raster.textContent = '';
        var n = 0;
        ps.forEach(function (p, j) {
          var idee = ideeVan(p, tab, Boolean(kaartHandle) && j === 0);
          if (idee) { raster.appendChild(bouwIdee(idee)); n++; }
        });
        ideeen.querySelector('[data-vl-ideeen-niets]').hidden = n > 0;
        raster.removeAttribute('aria-busy');
        VL.werkUiBij();
      });
    }

    ideeen.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-vl-tab]');
      if (knop) kies(parseInt(knop.getAttribute('data-vl-tab'), 10), false);
    });
    ideeen.addEventListener('keydown', function (e) {
      var knop = e.target.closest('[data-vl-tab]');
      if (!knop) return;
      var i = parseInt(knop.getAttribute('data-vl-tab'), 10);
      var n = tabs.length;
      var doel = { ArrowRight: (i + 1) % n, ArrowLeft: (i - 1 + n) % n, Home: 0, End: n - 1 }[e.key];
      if (doel === undefined) return;
      e.preventDefault();
      kies(doel, true);
    });

    /* ── Digitale schoen (opt-in voor de tips) ────────────────────────── */
    var schoenForm = schoen.querySelector('[data-vl-schoenform]');
    var schoenKlaar = schoen.querySelector('[data-vl-schoenklaar]');
    var schoenFout = schoen.querySelector('[data-vl-schoenfout]');
    function werkSchoenBij() {
      var aan = Boolean(huidige && (huidige.emailOptin === true || huidige.email_optin === true));
      schoenForm.hidden = aan;
      schoenKlaar.hidden = !aan;
    }

    schoenForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var knop = schoenForm.querySelector('button[type="submit"]');
      var email = schoenForm.elements.email;
      var body = { emailOptin: true };
      schoenFout.hidden = true;
      if (email) {
        var waarde = email.value.trim();
        if (!waarde || !email.checkValidity()) {
          schoenFout.textContent = T.emailOngeldig;
          schoenFout.hidden = false;
          email.setAttribute('aria-invalid', 'true');
          email.focus();
          return;
        }
        email.removeAttribute('aria-invalid');
        body.email = waarde;
      }
      knop.disabled = true;
      VL.api('PATCH', lijstPad(), body).then(function (data) {
        huidige = Object.assign({}, huidige, { emailOptin: true });
        if (data && data.lijst && data.lijst.emailOptin === false) huidige.emailOptin = false;
        werkSchoenBij();
        VL.meld(T.opgeslagen, false);
      }, function (f) {
        schoenFout.textContent = f && f.code === 'ONGELDIG_EMAIL' ? T.emailOngeldig : VL.foutTekst(f);
        schoenFout.hidden = false;
      }).then(function () { knop.disabled = false; });
    });

    schoen.querySelector('[data-vl-afmelden]').addEventListener('click', function (e) {
      var knop = e.currentTarget;
      knop.disabled = true;
      VL.api('PATCH', lijstPad(), { emailOptin: false }).then(function () {
        huidige = Object.assign({}, huidige, { emailOptin: false });
        werkSchoenBij();
        VL.meld(T.afgemeld, false);
      }, function (f) { VL.meld(VL.foutTekst(f), false); }).then(function () { knop.disabled = false; });
    });

    /* ── Deelvenster ──────────────────────────────────────────────────── */
    var naamVeld = sheet.querySelector('[data-vl-naam]');
    var naamHulp = sheet.querySelector('[data-vl-naam-hulp]');
    var naamHulpTekst = naamHulp.textContent;
    var rijmBlok = sheet.querySelector('[data-vl-rijm]');
    var rijmAan = sheet.querySelector('[data-vl-rijm-aan]');
    var rijmTekst = sheet.querySelector('[data-vl-rijm-tekst]');
    var rijmAnder = sheet.querySelector('[data-vl-rijm-ander]');
    var waKnop = sheet.querySelector('[data-vl-deel="whatsapp"]');
    var kopieerKnop = sheet.querySelector('[data-vl-deel="kopieer"]');
    var rijmen = [];
    var rijmIndex = 0;
    var opener = null;

    function deelUrl() {
      if (huidige && typeof huidige.deelUrl === 'string' && /^https:\/\//.test(huidige.deelUrl)) return huidige.deelUrl;
      var pad = String(DATA.deelPad || '/pages/verlanglijst/');
      if (pad.charAt(pad.length - 1) !== '/') pad += '/';
      return location.origin + pad + encodeURIComponent(VL.stand().token);
    }

    function gekozenRijm() {
      return rijmAan && rijmAan.checked ? rijmTekst.textContent : '';
    }

    function werkWhatsappBij() {
      var tekst = VL.pure.vulLink(DATA.whatsapp, deelUrl());
      var rijm = gekozenRijm();
      if (rijm) tekst = rijm + '\n\n' + tekst;
      waKnop._waUrl = 'https://wa.me/?text=' + encodeURIComponent(tekst);
      waKnop.href = waKnop._waUrl;
    }

    function zetRijm(tekst) {
      rijmTekst.textContent = tekst;
      werkWhatsappBij();
    }

    function toonRijm() {
      var aan = Boolean(rijmAan && rijmAan.checked);
      rijmTekst.hidden = !aan;
      rijmAnder.hidden = !aan || rijmen.length < 2;
      if (aan && !rijmTekst.textContent && rijmen.length) zetRijm(rijmen[rijmIndex % rijmen.length].tekst);
      werkWhatsappBij();
    }

    if (rijmBlok) {
      content().then(function (c) {
        var lijst = seizoen === 'kerst' ? c.kerstwensen : c.rijmpjes_sint;
        rijmen = (Array.isArray(lijst) ? lijst : []).filter(function (r) { return r && typeof r.tekst === 'string' && r.tekst.length <= 500; });
        if (!rijmen.length) return;
        rijmIndex = Math.floor(Math.random() * rijmen.length);
        rijmBlok.hidden = false;
        toonRijm();
      });
      rijmAan.addEventListener('change', function () { toonRijm(); opslaanDeel(false); });
      rijmAnder.addEventListener('click', function () {
        rijmIndex++;
        zetRijm(rijmen[rijmIndex % rijmen.length].tekst);
        opslaanDeel(false);
      });
    }

    function naamFout(aan) {
      naamHulp.textContent = aan ? T.naamLeeg : naamHulpTekst;
      naamHulp.classList.toggle('vl-hulp--fout', aan);
      if (aan) naamVeld.setAttribute('aria-invalid', 'true'); else naamVeld.removeAttribute('aria-invalid');
    }

    /* Naam en rijm opslaan als ze anders zijn dan op de server. keepalive: het verzoek loopt door als de
       bezoeker meteen naar WhatsApp gaat. */
    function opslaanDeel(keepalive) {
      if (!huidige) return Promise.resolve();
      var body = {};
      var naam = naamVeld.value.trim().slice(0, 60);
      if (naam && naam !== huidige.naam) body.naam = naam;
      var rijm = rijmBlok ? gekozenRijm().slice(0, 1000) : null;
      if (rijm !== null && rijm !== (huidige.rijm || '')) body.rijm = rijm;
      if (!Object.keys(body).length) return Promise.resolve();
      Object.assign(huidige, body);
      return VL.api('PATCH', lijstPad(), body, { keepalive: keepalive }).catch(function () {
        /* Volgende keer opnieuw: de lokale stand vergeten zodat het verschil blijft. */
        if (body.naam) huidige.naam = '';
      });
    }

    function logDeel(kanaal) {
      /* Fire-and-forget: een mislukte log mag het delen nooit tegenhouden. */
      VL.api('POST', lijstPad() + '/gedeeld', { kanaal: kanaal }, { keepalive: true }).catch(function () {});
    }

    function naamOk() {
      if (naamVeld.value.trim()) { naamFout(false); return true; }
      naamFout(true);
      naamVeld.focus();
      return false;
    }

    function openSheet(e) {
      if (!huidige) return;
      opener = e && e.currentTarget;
      if (!naamVeld.value) naamVeld.value = standaardNaam(huidige.naam) ? String(DATA.voornaam || '').slice(0, 60) : huidige.naam;
      naamFout(false);
      if (rijmAan && !rijmAan.dataset.gezet) {
        rijmAan.dataset.gezet = '1';
        if (huidige.rijm) { rijmAan.checked = true; rijmTekst.textContent = huidige.rijm; }
      }
      if (rijmBlok) toonRijm();
      werkWhatsappBij();
      sheet.querySelector('[data-vl-bekijk]').href = deelUrl();
      document.documentElement.classList.add('vl-sheet-open');
      if (typeof sheet.showModal === 'function') sheet.showModal(); else sheet.setAttribute('open', '');
      (naamVeld.value ? waKnop : naamVeld).focus();
    }

    function sluitSheet() {
      if (typeof sheet.close === 'function') sheet.close(); else sheet.removeAttribute('open');
    }

    sheet.addEventListener('close', function () {
      document.documentElement.classList.remove('vl-sheet-open');
      if (opener) opener.focus();
    });
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) sluitSheet(); /* klik op de achtergrond */
    });
    sheet.querySelector('[data-vl-sluit]').addEventListener('click', sluitSheet);
    naamVeld.addEventListener('input', function () { if (naamVeld.value.trim()) naamFout(false); });
    naamVeld.addEventListener('change', function () { if (naamVeld.value.trim()) opslaanDeel(false); });

    waKnop.addEventListener('click', function (e) {
      e.preventDefault();
      if (!naamOk()) return;
      werkWhatsappBij();
      opslaanDeel(true);
      logDeel('whatsapp');
      window.open(waKnop._waUrl, '_blank', 'noopener');
    });

    kopieerKnop.addEventListener('click', function () {
      if (!naamOk()) return;
      opslaanDeel(false);
      var label = kopieerKnop.querySelector('span');
      var oud = label.textContent;
      var klaar = function (tekst) {
        label.textContent = tekst;
        setTimeout(function () { label.textContent = oud; }, 2500);
      };
      var url = deelUrl();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { klaar(T.gekopieerd); logDeel('kopie'); }, function () { klaar(T.kopieerMislukt); });
      } else {
        klaar(T.kopieerMislukt);
      }
    });

    balk.querySelector('[data-vl-deel-open]').addEventListener('click', openSheet);

    /* ── Start ────────────────────────────────────────────────────────── */
    wortel.querySelector('[data-vl-opnieuw]').addEventListener('click', laad);
    bouwTabs();
    laad();
  }

  if (window.Verlanglijst) init();
  else document.addEventListener('verlanglijst:klaar', init);
})();
